import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { RegistrationFilterDto } from '../Mza/Entities/Dtos/registrationfilterdto.entity';
//#endregion

@Injectable()
export class RegistrationFilterDtoService extends ODataEntityService<RegistrationFilterDto> {
  constructor(protected client: ODataClient) {
    super(client, 'RegistrationFilterDto', 'Mza.Entities.Dtos.RegistrationFilterDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
